import { getClientConfig } from './client';
import { getServerConfig } from './server';
import type { Config } from './types';

export const config: Config =
  typeof window === 'undefined' ? getServerConfig() : getClientConfig();
